import { render, staticRenderFns } from "./dashboard-table-data.vue?vue&type=template&id=3378edc9&scoped=true&"
import script from "./dashboard-table-data.vue?vue&type=script&lang=js&"
export * from "./dashboard-table-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3378edc9",
  null
  
)

export default component.exports